import ComingSoon from "@/components/ComingSoon";
import UnderConstructionSvg from "@/components/UnderConstructionSvg";

const DeviceEnrollmentPage = () => {
  return <ComingSoon featureName="Under Construction" description="Enroll new devices into management. This feature requires backend End-User Portal APIs." illustration={<UnderConstructionSvg />} />;
};

export default DeviceEnrollmentPage;
